import { __assign } from '../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var ShieldIcon = function (_a) {
    var className = _a.className;
    return (jsxs("svg", __assign({ className: className, width: "26", height: "26", viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [jsx("title", { children: "shield" }), jsx("path", { d: "M13 25C13 25 1 20.7136 1 4.4288L13 1L25 4.4288C25 20.7136 13 25 13 25Z", stroke: "#6F757C", strokeWidth: "1.1", strokeLinecap: "round", strokeLinejoin: "round" }), jsx("path", { d: "M17.2498 11.4016C17.2498 13.7488 15.347 15.6516 12.9998 15.6516C10.6526 15.6516 8.74983 13.7488 8.74983 11.4016C8.74983 9.05435 10.6526 7.15156 12.9998 7.15156C15.347 7.15156 17.2498 9.05435 17.2498 11.4016Z", stroke: "#6F757C", strokeWidth: "1.1" })] })));
};

export { ShieldIcon };
